"use strict";

var _this = void 0;
/* eslint-disable import/no-unresolved */
/* eslint-disable import/no-extraneous-dependencies */
var angular = require('angular');
require('angular-moment');
require('loki-angular');
require('ng-infinite-scroll');
require('angular-google-analytics');
require('textangular/dist/textAngular-rangy.min');
var angularDragula = require('angularjs-dragula');
angular.module('app', [require('angular-animate'), require('angular-sanitize'), require('angular-aria'), require('angular-messages'), require('angular-resource'), require('angular-route'), require('angular-touch'), require('angular-cookies'), require('textangular'), require('angular-ui-bootstrap'), require('ng-array-filter'), require('ng-group-by'), require('ng-file-upload'), 'ngTagsInput', 'ngIdle', 'lokijs', 'angular-google-analytics', 'angularMoment', 'infinite-scroll', require('./templates.js').name, angularDragula(angular)]).config(function ($provide, $qProvider, $httpProvider, $routeProvider, AnalyticsProvider, tagsInputConfigProvider, ENV, IdleProvider, IDLE_TIMEOUT, IDLE_TIMEOUT_WARNING) {
  var environment = ENV === 'production' ? 'prod' : 'dev';
  var idleTimer = IDLE_TIMEOUT - IDLE_TIMEOUT_WARNING;
  if (idleTimer < 0) {
    idleTimer = 0;
  }
  IdleProvider.idle(idleTimer);
  IdleProvider.timeout(IDLE_TIMEOUT_WARNING);
  IdleProvider.interrupt('keydown wheel mousedown touchstart touchmove scroll');
  // TODO: remove when angular fixes this
  $qProvider.errorOnUnhandledRejections(false);
  tagsInputConfigProvider.setDefaults('tagsInput', {
    minLength: 1
  });
  $provide.decorator('taOptions', ['taRegisterTool', '$delegate', function (taRegisterTool, taOptions) {
    taRegisterTool('superscript', {
      iconclass: 'fa fa-superscript',
      tooltiptext: 'Superscript',
      action: function action() {
        return _this.$editor().wrapSelection('superscript', null);
      },
      activeState: function activeState() {
        return _this.$editor().queryCommandState('subscript');
      }
    });
    taRegisterTool('subscript', {
      iconclass: 'fa fa-subscript',
      tooltiptext: 'Subscript',
      action: function action() {
        return _this.$editor().wrapSelection('subscript', null);
      },
      activeState: function activeState() {
        return _this.$editor().queryCommandState('subscript');
      }
    });

    // eslint-disable-next-line no-param-reassign
    taOptions.forceTextAngularSanitize = false;
    // eslint-disable-next-line no-param-reassign
    taOptions.toolbar = [['bold', 'italics', 'underline', 'strikeThrough', 'subscript', 'superscript'], ['ul', 'ol']];
    return taOptions;
  }]);
  $provide.decorator('taTools', ['$delegate', function (taTools) {
    // eslint-disable-next-line no-param-reassign
    taTools.clear.iconclass = 'fa fa-eraser';
    return taTools;
  }]);
  AnalyticsProvider.setAccount([{
    tracker: 'UA-72733423-1',
    name: 'Inspect',
    trackEvent: true
  }, {
    tracker: 'UA-68039111-1',
    name: 'ucSafety'
  }]).trackPages(true).trackUrlParams(true).trackPrefix("inspect-".concat(environment)).setPageEvent('$routeChangeSuccess').readFromRoute(true);

  // eslint-disable-next-line no-param-reassign
  $httpProvider.defaults.cache = false;
  if (!$httpProvider.defaults.headers.get) {
    // eslint-disable-next-line no-param-reassign
    $httpProvider.defaults.headers.get = {};
  }
  // disable IE ajax request caching
  // eslint-disable-next-line no-param-reassign
  $httpProvider.defaults.headers.get['If-Modified-Since'] = '0';
  $httpProvider.interceptors.push('InterceptorService');
  $routeProvider.when('/', {
    templateUrl: 'home/home.html',
    controller: 'HomeCtrl',
    controllerAs: 'ctrl',
    pageTrack: '/home',
    resolve: {
      sidemenu: function sidemenu(SideMenuService) {
        SideMenuService.setActive('Inspect');
      }
    }
  }).when('/report-create', {
    templateUrl: 'report/create/report.create.html',
    controller: 'ReportCreateCtrl',
    controllerAs: 'ctrl',
    pageTrack: '/report-create',
    resolve: {
      configurations: function configurations(SideMenuService, ProgramService) {
        SideMenuService.setActive('Start Inspection');
        return ProgramService.findAllConfigurations().$promise;
      },
      configuration: function configuration($q, $location, ProgramService, ProfileService) {
        return $q(function (resolve, reject) {
          if ($location.search() && $location.search().appName) {
            return ProgramService.findProgramByIntegratedWithApp({
              campusCode: ProfileService.getProfile().campusCode,
              appName: $location.search().appName
            }).$promise.then(function (program) {
              if (program && program.configurations && program.configurations.length) {
                resolve(program.configurations[0]);
              } else {
                resolve(null);
              }
            })["catch"](reject);
          }
          return resolve(null);
        });
      }
    },
    reloadOnSearch: false
  }).when('/report', {
    templateUrl: 'report/list/report.list.html',
    controller: 'ReportListCtrl',
    controllerAs: 'ctrl',
    pageTrack: '/report-list',
    resolve: {
      sidemenu: function sidemenu(SideMenuService) {
        SideMenuService.setActive('Inspection Reports');
      },
      uniqGroups: function uniqGroups(RoutingGroupService) {
        return RoutingGroupService.getUniqGroups().$promise;
      },
      uniqTags: function uniqTags(ChecklistService) {
        return ChecklistService.getUniqTags().$promise;
      }
    },
    reloadOnSearch: false
  }).when('/report/:id', {
    templateUrl: 'report/detail/report.detail.html',
    controller: 'ReportDetailCtrl',
    controllerAs: 'ctrl',
    pageTrack: '/report-detail',
    resolve: {
      report: function report($route, ReportService, SideMenuService) {
        SideMenuService.setActive('Inspection Reports');
        var id = $route.current.params.id;
        var reportId = id.match(/^[^#]*#[^#]*$/) ? id.split('#')[0] : id;
        return ReportService.get({
          id: reportId
        });
      },
      isPublicView: function isPublicView() {
        return false;
      }
    },
    reloadOnSearch: false
  }).when('/public/report/:shareableToken', {
    templateUrl: 'report/detail/report.detail.html',
    controller: 'ReportDetailCtrl',
    controllerAs: 'ctrl',
    pageTrack: '/report-detail',
    resolve: {
      report: function report($route, ReportService, SideMenuService) {
        SideMenuService.setActive('Inspection Reports');
        return ReportService.getPublic({
          shareableToken: $route.current.params.shareableToken
        }).$promise;
      },
      isPublicView: function isPublicView() {
        return true;
      }
    },
    reloadOnSearch: false
  }).when('/report/:reportId/finding/:findingId/incident/:incidentId', {
    templateUrl: 'report/finding-incident/report.finding.incident-edit.html',
    controller: 'EditIncidentCtrl',
    controllerAs: 'ctrl',
    reloadOnSearch: false,
    resolve: {
      report: function report($route, ReportService, SideMenuService) {
        SideMenuService.setActive('Inspection Reports');
        return ReportService.get({
          id: $route.current.params.reportId
        });
      },
      findingId: function findingId($route) {
        return $route.current.params.findingId;
      },
      incidentId: function incidentId($route) {
        return $route.current.params.incidentId;
      },
      currentUser: function currentUser(ProfileService) {
        return ProfileService.getProfile();
      }
    }
  }).when('/management', {
    templateUrl: 'management/management.html',
    controller: 'ManagementCtrl',
    controllerAs: 'ctrl',
    reloadOnSearch: false,
    resolve: {
      programs: function programs(ProgramService, SideMenuService, ProfileService) {
        SideMenuService.setActive('Management');
        return ProgramService.findByRole({
          role: ProfileService.isSuperUser() ? 'SUPER_USER' : 'ADMIN'
        }).$promise;
      },
      campuses: function campuses(CampusService) {
        return CampusService.query().$promise;
      }
    }
  }).when('/service-desk', {
    templateUrl: 'service-desk/service-desk.html',
    controller: 'ServiceDeskCtrl',
    controllerAs: 'ctrl',
    resolve: {
      superUsers: function superUsers(ServiceDeskService, SideMenuService) {
        SideMenuService.setActive('Service Desk');
        return ServiceDeskService.getSuperUsers().$promise;
      }
    }
  }).when('/resources', {
    templateUrl: 'resources/resources.html',
    resolve: {
      sidemenu: function sidemenu(SideMenuService) {
        SideMenuService.setActive('Resources');
      }
    }
  }).when('/error', {
    templateUrl: 'navigation/error.html',
    controller: 'ErrorCtrl',
    controllerAs: 'ctrl'
  }).otherwise({
    resolve: {
      error: function error(ErrorService) {
        ErrorService.addError({
          status: 404,
          statusText: 'Page Not found'
        });
      }
    },
    redirectTo: '/error'
  });
}).run(function (Idle) {
  Idle.watch();
});
angular.module('app').constant('moment', require('moment-timezone')).directive('sidemenu', require('./navigation/uc-sidemenu')).directive('options', require('./shared/options.directive')).directive('item', require('./shared/option.menu.item.directive')).directive('personSearch', require('./shared/components/person-search/person.search')).directive('personMultiSearch', require('./shared/components/person-multi-search/person.multi.search')).directive('buildingSearch', require('./shared/components/building-search/building.search')).directive('incidentDetails', require('./shared/components/incident-details/incident.details')).directive('lightboxView', require('./shared/components/lightbox-view/lightbox.view')).directive('attachmentList', require('./shared/components/attachment-list/attachment.list')).filter('camelcase', require('./shared/filter/camelcase.filter')).filter('csscase', require('./shared/filter/csscase.filter')).filter('encodeURI', require('./shared/filter/encode.filter')).filter('enum', require('./shared/filter/enum.filter')).filter('address', require('./shared/filter/address.filter')).filter('search', require('./shared/filter/search.filter')).filter('timeAgo', require('./shared/filter/time-ago.filter')).filter('onOff', require('./shared/filter/on-off.filter.js')).factory('InterceptorService', require('./interceptor.service')).factory('ConfigService', require('./shared/config.service')).factory('EmailService', require('./shared/components/email/email.service')).factory('ProfileService', require('./shared/profile.service')).factory('PersonService', require('./shared/person.service')).factory('PlatformService', require('./shared/platform.service')).factory('ErrorService', require('./navigation/error.service')).factory('BrandService', require('./navigation/brand.service.js')).factory('SideMenuService', require('./navigation/sidemenu.service')).factory('LokiService', require('./shared/loki.service')).factory('PartyService', require('./shared/party.service')).factory('LocationService', require('./shared/location.service')).factory('ReportService', require('./shared/report.service')).factory('ChecklistService', require('./shared/checklist.service')).factory('ProgramService', require('./shared/program.service')).factory('PersonService', require('./shared/person.service')).factory('PreferenceService', require('./shared/preference.service')).factory('RoutingGroupService', require('./shared/routing.group.service')).factory('PartyToPeopleService', require('./shared/party-to-people.service')).factory('InvitationService', require('./shared/invitation.service')).factory('PartyToLocationService', require('./shared/party-to-location.service')).factory('CampusService', require('./shared/campus.service')).factory('ServiceDeskService', require('./shared/service-desk.service')).factory('ConfirmModelService', require('./shared/components/confirm-model/confirm.model.service')).factory('IdleHelper', require('./activity-manager/idle.helper')).controller('ErrorCtrl', require('./navigation/error.controller')).controller('ActivityCtrl', require('./activity-manager/activity.controller')).controller('NavigationCtrl', require('./navigation/navigation.controller')).controller('HomeCtrl', require('./home/home.controller')).controller('ReportCreateCtrl', require('./report/create/report.create.controller')).controller('ReportListCtrl', require('./report/list/report.list.controller')).controller('ReportDetailCtrl', require('./report/detail/report.detail.controller')).controller('OpenFindingsCtrl', require('./open-findings/open-findings.controller')).controller('ManagementCtrl', require('./management/management.controller')).controller('ManagementProgramCtrl', require('./management/program/program.controller.js')).controller('ManagementPartyCtrl', require('./management/party/party.controller')).controller('ManagementGroupCtrl', require('./management/routing-group/routing.group.controller')).controller('ManagementChecklistCtrl', require('./management/checklist/checklist.controller')).controller('ConfigurationCtrl', require('./management/configuration/configuration.controller')).controller('EditIncidentCtrl', require('./report/finding-incident/report.finding.incident-edit.controller')).controller('ServiceDeskCtrl', require('./service-desk/service-desk.controller')).component('appNavigation', {
  templateUrl: 'navigation/navigation.html',
  controller: 'NavigationCtrl',
  controllerAs: 'navi'
}).component('activityManager', {
  template: '<section></section>',
  controller: 'ActivityCtrl',
  controllerAs: 'activity'
});